export const RESPONA_AUTHOR_NAME = 'Respona';

export const MESSAGE_THREAD_ATTACHMENT_ICON_COLOR = '#525979';
export const MESSAGE_THREAD_DOWNLOAD_ICON_COLOR = '#8E95AA';
export const MESSAGE_THREAD_ATTACHMENT_ICON_SIZE = 14;
